import moment from 'moment';
import fields from "./fields.utils.js";

const schema_motor_trade = {
    ...fields.notes,
    'caravan_park': {
        label: 'caravan park',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },

    //source
    'source_uuid': {
        type: 'select',
        label: 'source',
        value: '',
        options: [],
        required: true,
    },
    'address1': {
        label: 'Address Line 1',
        placeholder: 'Address Line 1',
        value: '',
        type: 'text',
        required: true,

    },
    'address2': {
        label: 'Address Line 2',
        placeholder: 'Address Line 2',
        value: '',
        type: 'text',
    },
    'address3': {
        label: 'Address Line 3',
        placeholder: 'Address Line 3',
        type: 'text',
        value: '',
    },
    'address4': {
        label: 'Address Line 4',
        placeholder: 'Address Line 4',
        type: 'text',
        value: '',
    },
    'city': {
        label: 'City',
        placeholder: 'City',
        type: 'text',
        value: '',
        required: true,
    },
    'postcode': {
        label: 'Postal Code',
        placeholder: 'Postal Code',
        type: 'address-lookup',
        value: '',
        required: true,
    },
    'first_name': {
        label: 'First Name',
        placeholder: 'First Name',
        type: 'text',
        value: '',
        required: true,
    },
    'last_name': {
        label: 'Last Name',
        placeholder: 'Last Name',
        type: 'text',
        value: '',
        required: true,
    },
    'date_of_birth': {
        label: 'Date of birth',
        type: 'date-mask',
        value: '',
        required: true,
        placeholder: 'Date of Birth',
    },
    'uk_since': {
        label: 'uk since birth',
        value: true,
        type: 'bool',
        required: true,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
    },
    'uk_since_date': {
        label: 'uk since date',
        value: '',
        type: 'date-mask',
        required: true,
        placeholder: 'Uk Since Date',
    },
    'licence_type': {
        label: 'Licence type',
        type: 'select',
        value: '',
        options: [],
        required: true,
    },
    'licence_date': {
        label: 'Licence date',
        value: '',
        type: 'date-mask',
        required: true,
        placeholder: 'Licence Date',
    },
    'has_criminal_convictions': {
        label: 'criminal convictions',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
    },
    'occupation_x_type': {
        value: '',
        type: 'auto-suggest',
        required: true,
        options: [],
    },
    'occupation_x_full_time': {
        label: 'Full Time',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
    },
    'claim_x_type': {
        label: 'Type',
        type: 'select',
        value: '',
        options: [],
        orderOptions: false,
        placeholder: 'Claim Type',
    },
    'claim_x_date': {
        label: 'Date',
        type: 'date-mask',
        value: moment().format('DD/MM/YYYY'),
        placeholder: 'Claim Date',
    },
    'conviction_x_type': {
        label: 'Conviction Type',
        type: 'select',
        value: '',
        options: [],
        placeholder: 'Conviction Type',
    },
    'conviction_x_points': {
        label: 'Conviction points',
        type: 'number',
        value: 0,
        placeholder: 'Conviction Points',
    },
    "conviction_x_ban": {
        label: "Conviction Ban",
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
    },
    'ncb_years_private': {
        label: 'Ncb Private Years',
        type: 'number',
        value: 0,
        required: true,
        placeholder: 'Ncb Private Years',
    },
    'ncb_years_motor_trade': {
        label: 'Ncb Motor Trade Years',
        type: 'number',
        value: 0,
        required: true,
        placeholder: 'Ncb Motor Trade Years',
    },
    'road_use': {
        label: 'Road Use',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'premises_cover': {
        label: 'Premises Cover',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'weight_over_75': {
        label: 'Weight Over 7.5 tonne',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'value': {
        label: 'Value',
        type: 'number',
        value: 0,
        required: true,
        placeholder: 'value',
    },
    'email': {
        label: 'Email Address',
        placeholder: 'Email Address',
        type: 'email',
        value: '',
    },
    'telephone': {
        label: 'Telephone',
        placeholder: 'Telephone',
        type: 'text',
        value: '',
        required: true,
    },
    'motor_trade_service': {
        label: 'Service',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'motor_trade_mot': {
        label: 'MOT',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'motor_trade_repairs': {
        label: 'Repairs',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'motor_trade_body_shop': {
        label: 'Body Shop',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'motor_trade_valeting': {
        label: 'Valeting',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'motor_trade_park': {
        label: 'Car Park',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'motor_trade_delivery': {
        label: 'Delivery',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'motor_trade_recovery': {
        label: 'Recovery',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'motor_trade_buy_sell': {
        label: 'Buy/Sell',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'motor_trade_scrap': {
        label: 'Scrap',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },

    'motor_trade_from': {
        type: 'select',
        label: 'Motor trade From',
        value: '',
        options: [],
        required: true,
    },
    'business_postcode': {
        label: 'Business Postal Code',
        placeholder: 'Business Postal Code',
        type: 'text',
        value: '',
        required: true,
    },
    'previous_policy_cancelled': {
        label: 'previous policy cancelled',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'kit_car': {
        label: 'Modified / High Performance',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'company_name': {
        type: 'text',
        label: 'company name',
        value: '',
        options: [],
        required: true,
    },
    'company_age': {
        label: 'company establishment year',
        type: 'number',
        value: moment().year(),
        required: true,
        placeholder: 'Company Year',
    },
    'cover_date': {
        label: 'Cover Date',
        type: 'date-picker',
        value: moment().format('DD/MM/YYYY'),
        required: true,
        placeholder: 'Cover Date',
    },
    'cover_duration': {
        label: 'Cover Duration in months',
        type: 'select',
        value: '',
        options: [],
        required: true,
    },
    "dob_youngest_driver": {
        label: 'Date of birth for the Youngest driver',
        type: 'date-mask',
        value: '',
        placeholder: 'Date of Birth Youngest Driver'
    },
    //dob_oldest_driver set by default on back end
    ...fields.marketing,
    ...fields.title,
    ...fields.cross_selling
};
export default schema_motor_trade;
